var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-trash",
  "use": "ring-icon-trash-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-trash\"><path d=\"M13.27 2h-2.1v-.15A1.34 1.34 0 0 0 9.79.55H6.21a1.34 1.34 0 0 0-1.38 1.3V2h-2.1C1.4 2 1 2.72 1 3.63V4h14v-.37A1.52 1.52 0 0 0 13.27 2zm-1.09 4.5l-1.12 7.19c-.14.6-.25.79-1.08.79H6c-.81 0-.83 0-1.08-.84L3.77 6.5 3.52 5H2l1.47 9c.44 1.53.95 2 2.54 2h4a2.27 2.27 0 0 0 2.55-2l1.41-9h-1.55z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id